import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaInstagram, FaFacebook, FaWhatsapp } from 'react-icons/fa';
import { getSiteBilgileri } from '../services/api';
import './Footer.css';

const Footer = () => {
  const [ayar, setAyar] = useState(null);

  useEffect(() => {
    getSiteBilgileri()
      .then(res => setAyar(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-title">
            <span className="logo-karpat">KARPAT</span> <span className="logo-oto">OTOMOTİV</span>
          </h3>
          <p className="footer-desc">
            Güvenilir oto servis hizmetleri ile aracınız emin ellerde. 
            Uzman kadromuzla her zaman yanınızdayız.
          </p>
          <div className="footer-social">
            {ayar?.instagram && <a href={ayar.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>}
            {ayar?.facebook && <a href={ayar.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>}
            <a href={`https://wa.me/${ayar?.whatsapp || '905320000000'}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Hızlı Bağlantılar</h4>
          <ul className="footer-links">
            <li><Link to="/">Ana Sayfa</Link></li>
            <li><Link to="/hizmetler">Hizmetler</Link></li>
            <li><Link to="/hakkimizda">Hakkımızda</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>
            <li><Link to="/randevu">Randevu Al</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Çalışma Saatleri</h4>
          <ul className="footer-hours">
            <li><span>Pazartesi - Cuma</span><span>{ayar?.hafta_ici_saatler || '08:00 - 18:00'}</span></li>
            <li><span>Cumartesi</span><span>{ayar?.cumartesi_saatler || '09:00 - 15:00'}</span></li>
            <li><span>Pazar</span><span>{ayar?.pazar_saatler || 'Kapalı'}</span></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>İletişim</h4>
          <ul className="footer-contact">
            <li><FaPhone /> <a href={`tel:${ayar?.telefon?.replace(/\s/g, '') || '05320000000'}`}>{ayar?.telefon || '0532 000 00 00'}</a></li>
            <li><FaEnvelope /> <a href={`mailto:${ayar?.email || 'info@karpatotomotiv.com'}`}>{ayar?.email || 'info@karpatotomotiv.com'}</a></li>
            <li><FaMapMarkerAlt /> {ayar?.adres || 'Organize Sanayi Bölgesi, İstanbul'}</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 Karpat Otomotiv. Tüm hakları saklıdır.</p>
      </div>
    </footer>
  );
};

export default Footer;
